// extracted by mini-css-extract-plugin
export default {"sectionBg":"styles_sectionBg__fpvjK","sectionWrapper":"styles_sectionWrapper__2L48f","card":"styles_card__QfDuO","logo":"styles_logo__bRw6m"};